import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="88"
    height="64"
    viewBox="0 0 88 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36.5605 53.6982C36.7835 55.2272 37.0957 58.9922 36.5605 61.8207H39.1884"
      stroke="#CF0A80"
      strokeWidth="1.52859"
      strokeLinecap="round"
    />
    <path
      d="M40.5254 53.1299C41.1784 54.5951 42.5321 58.0511 42.7232 60.1534H45.8767"
      stroke="#CF0A80"
      strokeWidth="1.52859"
      strokeLinecap="round"
    />
    <path
      d="M42.3889 48.0681C43.9656 47.5266 47.2242 45.4402 47.6446 41.4268"
      stroke="#CF0A80"
      strokeWidth="1.52859"
      strokeLinecap="round"
    />
    <path
      d="M36.4167 40.9876C40.9557 40.032 42.8669 46.4822 42.8669 48.3933C43.488 48.3933 44.6825 49.2056 44.8736 50.1134C45.0647 51.0212 44.5392 52.2861 43.3447 52.7891C42.7929 53.0214 40.6213 53.7446 38.8534 54.1269C37.0856 54.5091 34.84 54.4613 33.5977 54.4613C32.3554 54.4613 31.0654 53.6491 31.0176 52.2157C30.9794 51.069 32.021 50.2727 32.5466 50.0178C31.6865 46.2911 31.8777 41.9432 36.4167 40.9876Z"
      fill="url(#paint0_linear_984_3740)"
    />
    <ellipse
      cx="40.9367"
      cy="47.6442"
      rx="0.62113"
      ry="0.66891"
      transform="rotate(-17.4862 40.9367 47.6442)"
      fill="#3B314F"
    />
    <ellipse
      cx="37.592"
      cy="48.5109"
      rx="0.62113"
      ry="0.66891"
      transform="rotate(-17.4862 37.592 48.5109)"
      fill="#3B314F"
    />
    <path
      d="M33.2148 49.5933C33.8041 51.8867 34.6291 57.0086 33.2148 59.1491"
      stroke="#CF0A80"
      strokeWidth="1.52859"
      strokeLinecap="round"
    />
    <g opacity="0.2" filter="url(#filter0_f_984_3740)">
      <path
        d="M51.813 57.4693L39.0826 47.9892C37.7661 47.0089 36.9904 45.4641 36.9904 43.8227L36.9903 20.5046C36.9902 18.8982 37.7333 17.3823 39.003 16.3983L51.8887 6.41212C53.7325 4.98324 56.3026 4.95849 58.1736 6.35161L70.764 15.7266C72.0806 16.7069 72.8564 18.2518 72.8564 19.8933V43.2402C72.8564 44.8301 72.1283 46.3324 70.8805 47.3176L58.1349 57.3802C56.2904 58.8364 53.6979 58.873 51.813 57.4693Z"
        fill="#F9E05C"
      />
    </g>
    <path
      d="M55.5088 58.4805L35.2649 32.5458L55.417 25.5369L55.5088 58.4805Z"
      fill="#FFDAA4"
    />
    <path
      d="M55.5088 5.00396L75.7527 32.5431L55.417 25.5338L55.5088 5.00396Z"
      fill="#FFA827"
    />
    <path
      d="M55.509 58.4762L55.4172 25.533L75.7529 32.5419L55.509 58.4762Z"
      fill="#FFBC57"
    />
    <path
      d="M55.5094 5.0057L55.4176 25.5352L35.2656 32.5445L55.5094 5.0057Z"
      fill="#FFBC57"
    />
    <path
      d="M44.3614 35.6885C44.4628 35.6658 44.5252 35.5585 44.5006 35.449C44.4761 35.3395 44.374 35.2691 44.2725 35.2919C44.1711 35.3146 44.1088 35.4218 44.1333 35.5313C44.1578 35.6409 44.26 35.7112 44.3614 35.6885Z"
      fill="#FEFAD1"
    />
    <path
      d="M43.2599 31.5314C43.4504 31.4887 43.5674 31.2873 43.5213 31.0816C43.4753 30.8759 43.2835 30.7438 43.093 30.7865C42.9025 30.8292 42.7854 31.0305 42.8315 31.2362C42.8776 31.4419 43.0694 31.5741 43.2599 31.5314Z"
      fill="#FEFAD1"
    />
    <path
      d="M44.332 32.8868C44.473 32.8552 44.5597 32.7061 44.5255 32.5539C44.4914 32.4016 44.3495 32.3038 44.2085 32.3354C44.0674 32.367 43.9808 32.516 44.0149 32.6683C44.049 32.8206 44.191 32.9184 44.332 32.8868Z"
      fill="#FEFAD1"
    />
    <path
      d="M41.1395 31.3275C41.2124 31.3112 41.2573 31.2341 41.2396 31.1552C41.222 31.0764 41.1485 31.0258 41.0755 31.0422C41.0025 31.0585 40.9577 31.1357 40.9753 31.2145C40.993 31.2933 41.0665 31.3439 41.1395 31.3275Z"
      fill="#FEFAD1"
    />
    <path
      d="M40.9363 28.3491C40.9969 28.3356 41.0341 28.2715 41.0195 28.206C41.0048 28.1406 40.9438 28.0985 40.8832 28.1121C40.8226 28.1257 40.7853 28.1898 40.8 28.2552C40.8147 28.3207 40.8757 28.3627 40.9363 28.3491Z"
      fill="#FEFAD1"
    />
    <path
      d="M47.6376 28.1043C47.8458 28.0576 47.9738 27.8375 47.9234 27.6127C47.873 27.3878 47.6634 27.2434 47.4551 27.29C47.2469 27.3367 47.119 27.5568 47.1693 27.7816C47.2197 28.0065 47.4294 28.1509 47.6376 28.1043Z"
      fill="#FEFAD1"
    />
    <path
      d="M47.1121 29.564C47.2127 29.5415 47.2746 29.4351 47.2502 29.3265C47.2259 29.2179 47.1246 29.1481 47.024 29.1706C46.9234 29.1932 46.8615 29.2995 46.8859 29.4081C46.9102 29.5168 47.0115 29.5866 47.1121 29.564Z"
      fill="#FEFAD1"
    />
    <path
      d="M47.8795 26.8268C47.9488 26.8112 47.9913 26.738 47.9746 26.6632C47.9578 26.5884 47.8881 26.5404 47.8188 26.5559C47.7495 26.5714 47.7069 26.6446 47.7237 26.7194C47.7405 26.7942 47.8102 26.8423 47.8795 26.8268Z"
      fill="#FEFAD1"
    />
    <path
      d="M48.2591 34.5287C48.5362 34.4666 48.7065 34.1737 48.6395 33.8745C48.5724 33.5753 48.2934 33.3831 48.0164 33.4452C47.7393 33.5073 47.569 33.8002 47.636 34.0994C47.7031 34.3986 47.9821 34.5908 48.2591 34.5287Z"
      fill="#FEFAD1"
    />
    <path
      d="M52.1798 45.5748C52.3517 45.5362 52.4574 45.3545 52.4158 45.1688C52.3742 44.9832 52.201 44.8639 52.0291 44.9024C51.8572 44.9409 51.7515 45.1227 51.7931 45.3083C51.8347 45.494 52.0078 45.6133 52.1798 45.5748Z"
      fill="#FEFAD1"
    />
    <path
      d="M52.5436 42.3108C52.619 42.2939 52.6654 42.2142 52.6471 42.1327C52.6289 42.0512 52.5529 41.9989 52.4774 42.0158C52.402 42.0327 52.3556 42.1124 52.3739 42.1939C52.3921 42.2754 52.4681 42.3277 52.5436 42.3108Z"
      fill="#FEFAD1"
    />
    <path
      d="M48.0972 42.9552C48.2889 42.9122 48.4067 42.7095 48.3604 42.5025C48.314 42.2955 48.1209 42.1624 47.9292 42.2054C47.7375 42.2484 47.6196 42.451 47.666 42.6581C47.7124 42.8651 47.9055 42.9981 48.0972 42.9552Z"
      fill="#FEFAD1"
    />
    <path
      d="M51.5065 48.4853C51.7201 48.4375 51.8514 48.2117 51.7997 47.9811C51.748 47.7505 51.5329 47.6023 51.3194 47.6502C51.1058 47.698 50.9745 47.9238 51.0262 48.1544C51.0779 48.385 51.2929 48.5332 51.5065 48.4853Z"
      fill="#FEFAD1"
    />
    <path
      d="M46.9081 41.717C46.9844 41.6999 47.0312 41.6193 47.0128 41.5369C46.9943 41.4546 46.9175 41.4017 46.8412 41.4188C46.765 41.4359 46.7181 41.5165 46.7365 41.5988C46.755 41.6812 46.8318 41.7341 46.9081 41.717Z"
      fill="#FEFAD1"
    />
    <path
      d="M55.1037 11.2745C55.377 11.2132 55.545 10.9243 55.4789 10.6291C55.4127 10.3339 55.1375 10.1442 54.8641 10.2055C54.5908 10.2667 54.4228 10.5557 54.4889 10.8509C54.5551 11.1461 54.8303 11.3357 55.1037 11.2745Z"
      fill="#FEFAD1"
    />
    <path
      d="M64.6028 19.4692C64.757 19.4346 64.8518 19.2716 64.8145 19.1051C64.7772 18.9386 64.6219 18.8316 64.4677 18.8661C64.3135 18.9007 64.2187 19.0637 64.256 19.2302C64.2933 19.3967 64.4486 19.5037 64.6028 19.4692Z"
      fill="#FEFAD1"
    />
    <path
      d="M63.8076 16.5938C63.8871 16.576 63.936 16.4919 63.9168 16.406C63.8975 16.32 63.8174 16.2648 63.7378 16.2827C63.6583 16.3005 63.6094 16.3846 63.6286 16.4705C63.6479 16.5565 63.728 16.6117 63.8076 16.5938Z"
      fill="#FEFAD1"
    />
    <path
      d="M61.0238 13.8105C61.117 13.7896 61.1742 13.6911 61.1517 13.5905C61.1292 13.4898 61.0353 13.4252 60.9422 13.4461C60.849 13.467 60.7917 13.5655 60.8143 13.6661C60.8368 13.7667 60.9306 13.8313 61.0238 13.8105Z"
      fill="#FEFAD1"
    />
    <path
      d="M62.1328 18.6099C62.2433 18.5852 62.3112 18.4684 62.2845 18.349C62.2578 18.2297 62.1465 18.1531 62.036 18.1778C61.9255 18.2026 61.8576 18.3194 61.8843 18.4387C61.9111 18.558 62.0223 18.6347 62.1328 18.6099Z"
      fill="#FEFAD1"
    />
    <path
      d="M62.1508 22.7348C62.2535 22.7118 62.3166 22.6033 62.2918 22.4924C62.2669 22.3816 62.1635 22.3103 62.0609 22.3333C61.9582 22.3564 61.8951 22.4649 61.92 22.5757C61.9448 22.6866 62.0482 22.7578 62.1508 22.7348Z"
      fill="#FEFAD1"
    />
    <path
      d="M43.5507 16.3532C43.6089 16.3401 43.6446 16.2787 43.6305 16.2159C43.6165 16.1531 43.5579 16.1128 43.4998 16.1258C43.4417 16.1389 43.4059 16.2003 43.42 16.2631C43.4341 16.3259 43.4926 16.3662 43.5507 16.3532Z"
      fill="#FEFAD1"
    />
    <path
      d="M45.9296 21.2937C46.0978 21.256 46.2012 21.0782 46.1605 20.8965C46.1198 20.7148 45.9504 20.5981 45.7822 20.6358C45.6139 20.6735 45.5105 20.8514 45.5512 21.033C45.5919 21.2147 45.7613 21.3314 45.9296 21.2937Z"
      fill="#FEFAD1"
    />
    <path
      d="M44.4358 23.9858C44.59 23.9512 44.6848 23.7882 44.6475 23.6217C44.6102 23.4552 44.4549 23.3482 44.3007 23.3827C44.1465 23.4173 44.0517 23.5803 44.089 23.7468C44.1264 23.9133 44.2816 24.0203 44.4358 23.9858Z"
      fill="#FEFAD1"
    />
    <path
      d="M43.0161 22.0919C43.0759 22.0785 43.1126 22.0153 43.0982 21.9507C43.0837 21.8861 43.0235 21.8447 42.9637 21.8581C42.9039 21.8715 42.8672 21.9347 42.8817 21.9992C42.8961 22.0638 42.9563 22.1053 43.0161 22.0919Z"
      fill="#FEFAD1"
    />
    <path
      d="M40.9876 23.8433C41.108 23.8164 41.182 23.6891 41.1528 23.5591C41.1237 23.4291 41.0025 23.3456 40.8821 23.3725C40.7617 23.3995 40.6877 23.5268 40.7168 23.6568C40.7459 23.7868 40.8672 23.8703 40.9876 23.8433Z"
      fill="#FEFAD1"
    />
    <path
      d="M43.4018 26.8565C43.6241 26.8067 43.7606 26.5718 43.7069 26.3318C43.6531 26.0918 43.4293 25.9377 43.2071 25.9875C42.9849 26.0373 42.8483 26.2722 42.9021 26.5122C42.9558 26.7521 43.1796 26.9063 43.4018 26.8565Z"
      fill="#FEFAD1"
    />
    <path
      d="M54.2487 13.5517C54.3518 13.5286 54.4151 13.4196 54.3902 13.3083C54.3652 13.197 54.2614 13.1255 54.1583 13.1486C54.0553 13.1717 53.9919 13.2807 54.0168 13.392C54.0418 13.5033 54.1456 13.5748 54.2487 13.5517Z"
      fill="#FEFAD1"
    />
    <path
      d="M46.1494 12.5124C46.318 12.4746 46.4217 12.2964 46.3809 12.1143C46.3401 11.9322 46.1703 11.8152 46.0016 11.853C45.833 11.8908 45.7294 12.069 45.7702 12.2511C45.811 12.4332 45.9808 12.5502 46.1494 12.5124Z"
      fill="#FEFAD1"
    />
    <path
      d="M54.1541 8.09849C54.279 8.07049 54.3558 7.93844 54.3255 7.80353C54.2953 7.66862 54.1695 7.58196 54.0446 7.60995C53.9196 7.63795 53.8429 7.77001 53.8731 7.90491C53.9033 8.03982 54.0291 8.12649 54.1541 8.09849Z"
      fill="#FEFAD1"
    />
    <path
      d="M50.7303 15.6158C50.9414 15.5685 51.0712 15.3454 51.0201 15.1174C50.969 14.8895 50.7565 14.743 50.5453 14.7903C50.3342 14.8376 50.2045 15.0608 50.2556 15.2887C50.3067 15.5167 50.5192 15.6631 50.7303 15.6158Z"
      fill="#FEFAD1"
    />
    <path
      d="M55.4759 20.6048C55.6515 20.5655 55.7594 20.3798 55.7169 20.1901C55.6744 20.0005 55.4976 19.8786 55.3219 19.918C55.1463 19.9574 55.0384 20.143 55.0809 20.3327C55.1234 20.5223 55.3002 20.6442 55.4759 20.6048Z"
      fill="#FEFAD1"
    />
    <path
      d="M57.3427 20.721C57.4071 20.7066 57.4466 20.6386 57.431 20.5692C57.4155 20.4997 57.3507 20.4551 57.2864 20.4695C57.2221 20.4839 57.1825 20.5519 57.1981 20.6214C57.2137 20.6908 57.2784 20.7354 57.3427 20.721Z"
      fill="#FEFAD1"
    />
    <path
      d="M50.5981 22.1031C50.6974 22.0809 50.7585 21.9758 50.7345 21.8685C50.7104 21.7612 50.6104 21.6923 50.511 21.7146C50.4116 21.7368 50.3505 21.8419 50.3746 21.9492C50.3986 22.0565 50.4987 22.1254 50.5981 22.1031Z"
      fill="#FEFAD1"
    />
    <path
      d="M49.225 19.4858C49.3368 19.4608 49.4055 19.3427 49.3784 19.222C49.3514 19.1014 49.2389 19.0239 49.1271 19.0489C49.0154 19.0739 48.9467 19.1921 48.9738 19.3127C49.0008 19.4334 49.1133 19.5109 49.225 19.4858Z"
      fill="#FEFAD1"
    />
    <path
      d="M54.9084 14.9891C54.9826 14.9725 55.0282 14.894 55.0103 14.8139C54.9923 14.7338 54.9176 14.6823 54.8434 14.6989C54.7691 14.7155 54.7235 14.794 54.7415 14.8741C54.7595 14.9543 54.8342 15.0057 54.9084 14.9891Z"
      fill="#FEFAD1"
    />
    <path
      d="M53.3032 12.5411C53.3935 12.5208 53.449 12.4254 53.4271 12.3279C53.4053 12.2304 53.3143 12.1677 53.224 12.188C53.1337 12.2082 53.0783 12.3037 53.1001 12.4012C53.122 12.4987 53.2129 12.5613 53.3032 12.5411Z"
      fill="#FEFAD1"
    />
    <path
      d="M40.4194 34.794C40.5007 34.7758 40.5506 34.6899 40.5309 34.6022C40.5113 34.5145 40.4295 34.4581 40.3483 34.4763C40.267 34.4945 40.2171 34.5804 40.2368 34.6681C40.2564 34.7558 40.3382 34.8122 40.4194 34.794Z"
      fill="#FEFAD1"
    />
    <path
      d="M46.9134 15.7237C47.0433 15.6946 47.1231 15.5574 47.0917 15.4171C47.0603 15.2769 46.9295 15.1868 46.7996 15.2159C46.6697 15.245 46.5899 15.3822 46.6214 15.5225C46.6528 15.6627 46.7836 15.7528 46.9134 15.7237Z"
      fill="#FEFAD1"
    />
    <path
      d="M41.4951 35.2932C41.6728 35.2534 41.782 35.0656 41.739 34.8737C41.696 34.6818 41.5171 34.5585 41.3394 34.5983C41.1616 34.6381 41.0524 34.826 41.0954 35.0179C41.1384 35.2098 41.3174 35.333 41.4951 35.2932Z"
      fill="#FEFAD1"
    />
    <path
      d="M40.0562 15.6717C39.0994 16.1972 34.683 20.1329 30.0166 15.1157"
      stroke="#CF0A80"
      strokeWidth="1.52859"
      strokeLinecap="round"
    />
    <path
      d="M40.1444 6.25539C36.461 8.6505 38.2173 13.7245 39.5559 15.9621C37.836 17.5222 39.2525 21.7045 42.1451 20.8461C45.0376 19.9876 49.874 17.4031 51.2657 15.923C52.6574 14.443 52.6086 12.9595 51.8221 11.7881C51.193 10.851 49.6663 10.6864 48.9816 10.7213C48.5895 9.65542 44.7488 3.2615 40.1444 6.25539Z"
      fill="url(#paint1_linear_984_3740)"
    />
    <ellipse
      cx="41.885"
      cy="16.7125"
      rx="0.62113"
      ry="0.66891"
      transform="rotate(-32.9344 41.885 16.7125)"
      fill="#3B314F"
    />
    <ellipse
      cx="46.3391"
      cy="15.1265"
      rx="0.62113"
      ry="0.66891"
      transform="rotate(-32.9344 46.3391 15.1265)"
      fill="#3B314F"
    />
    <path
      d="M42.0649 20.5144C40.9028 21.396 39.7246 23.0952 40.1341 24.8315C40.4617 26.2205 43.0536 26.7067 44.3085 26.7762L43.375 29.5077"
      stroke="#CF0A80"
      strokeWidth="1.52859"
      strokeLinecap="round"
    />
    <path
      d="M47.3618 18.2199C46.4897 19.1211 45.2895 22.0707 46.1073 24.0551C46.7616 25.6427 48.9355 25.6513 49.9407 25.4571L49.8284 28.7325"
      stroke="#CF0A80"
      strokeWidth="1.52859"
      strokeLinecap="round"
    />
    <path
      d="M48.2781 10.8869C50.7148 9.7849 53.6596 8.96932 51.6456 2.10901"
      stroke="#CF0A80"
      strokeWidth="1.52859"
      strokeLinecap="round"
    />
    <path
      d="M62.6381 49.9814C63.0681 51.1759 65.0748 54.4727 64.2148 60.3495L61.5869 61.3529"
      stroke="#CF0A80"
      strokeWidth="1.52859"
      strokeLinecap="round"
    />
    <path
      d="M67.5586 51.2217C67.9408 52.0339 69.5175 55.3785 69.852 60.7298L72.4799 61.3987"
      stroke="#CF0A80"
      strokeWidth="1.52859"
      strokeLinecap="round"
    />
    <path
      d="M60.3443 47.832C60.1213 49.0106 59.8092 52.2755 60.3443 55.9067"
      stroke="#CF0A80"
      strokeWidth="1.52859"
      strokeLinecap="round"
    />
    <path
      d="M68.4671 39.1842C63.9758 37.9898 61.7302 43.5322 61.6824 44.6311C58.3379 44.6311 58.5854 47.6055 59.2935 48.5968C59.7712 49.2657 60.9657 50.4124 63.6414 51.3202C66.317 52.228 69.2315 52.6102 70.0438 52.5147C70.856 52.4191 71.9072 52.5147 72.6716 50.699C73.2832 49.2466 72.2257 48.0871 71.7161 47.689C72.2894 45.0133 72.9583 40.3787 68.4671 39.1842Z"
      fill="url(#paint2_linear_984_3740)"
    />
    <ellipse
      cx="63.5246"
      cy="45.1634"
      rx="0.62113"
      ry="0.66891"
      transform="rotate(23.8851 63.5246 45.1634)"
      fill="#3B314F"
    />
    <ellipse
      cx="67.7287"
      cy="46.4036"
      rx="0.62113"
      ry="0.66891"
      transform="rotate(23.8851 67.7287 46.4036)"
      fill="#3B314F"
    />
    <path
      d="M71.6201 48.4521C72.2572 50.0607 73.4071 54.0519 72.9102 57.148"
      stroke="#CF0A80"
      strokeWidth="1.52859"
      strokeLinecap="round"
    />
    <path
      d="M20.145 63.6075C23.0354 63.9597 23.3634 56.2253 23.2194 55.2206C21.5676 53.8165 19.6962 54.5606 18.9226 55.4634C19.5738 59.2952 17.2546 63.2552 20.145 63.6075Z"
      fill="#DE493C"
    />
    <path
      d="M30.3865 39.8813C32.3935 41.9266 25.5688 46.7855 24.6632 47.207C22.3282 46.273 24.5563 43.068 24.8845 41.945C28.393 40.4214 28.9597 38.4273 30.3865 39.8813Z"
      fill="url(#paint3_linear_984_3740)"
    />
    <path
      d="M24.4403 31.7859C20.483 25.4958 14.8185 25.4956 11.1737 28.6496C7.72002 32.3139 10.2029 36.5304 10.2029 40.0957C10.2029 43.5223 9.82932 45.0172 9.32514 49.0115C8.80332 53.1455 10.4938 59.2357 17.4273 58.6916C24.3607 58.1476 25.7828 49.4922 26.1202 46.7916C26.4576 44.091 27.7106 36.984 24.4403 31.7859Z"
      fill="url(#paint4_linear_984_3740)"
    />
    <path
      d="M21.1092 38.4605C22.8952 38.0025 24.0422 36.7626 24.4306 35.9472C23.9447 34.9181 22.6342 32.6511 21.2789 31.8168C19.5847 30.7738 17.3338 31.9431 16.3749 33.7377C15.6079 35.1734 15.4166 36.747 15.1673 37.8663C16.2696 38.4476 18.6857 39.082 21.1092 38.4605Z"
      fill="#FEF9F5"
    />
    <mask
      id="mask0_984_3740"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="17"
      y="31"
      width="7"
      height="7"
    >
      <path
        d="M23.0629 33.9957C23.2368 35.7556 22.1502 37.3037 20.6358 37.4534C19.1214 37.603 17.318 36.4011 17.1441 34.6411C16.9702 32.8811 18.4915 31.2297 20.0059 31.08C21.5203 30.9303 22.8889 32.2357 23.0629 33.9957Z"
        fill="black"
      />
    </mask>
    <g mask="url(#mask0_984_3740)">
      <path
        d="M21.192 39.188C22.9168 38.5367 24.1249 36.743 24.5133 35.9276C24.0275 34.8984 22.7169 32.6315 21.3616 31.7971C19.6675 30.7541 17.4165 31.9234 16.4577 33.7181C15.6906 35.1538 15.1952 37.2809 14.8764 38.2203C15.9787 38.8015 19.0359 40.0022 21.192 39.188Z"
        fill="black"
      />
    </g>
    <path
      d="M23.4984 39.9709C25.3429 42.1639 19.8388 46.1352 18.9332 46.5567C15.9017 46.6803 15.8002 44.4652 16.1285 43.3422C19.6369 41.8186 21.654 37.7778 23.4984 39.9709Z"
      fill="url(#paint5_linear_984_3740)"
    />
    <path
      d="M14.355 63.6075C17.2454 63.9597 17.5734 56.2253 17.4293 55.2206C15.7775 53.8165 13.9062 54.5606 13.1326 55.4634C13.7837 59.2952 11.4645 63.2552 14.355 63.6075Z"
      fill="url(#paint6_linear_984_3740)"
    />
    <path
      d="M23.4486 42.4438C20.273 46.2733 18.7785 46.678 18.3115 46.9271C18.654 46.9583 19.7508 46.7459 20.74 46.0865C21.5806 45.5261 23.2618 43.6581 23.4486 42.4438Z"
      fill="#DB422A"
    />
    <path
      d="M18.1252 20.2033C19.4329 20.0165 22.5898 18.5594 24.7567 14.2256"
      stroke="#CF0A80"
      strokeWidth="1.52859"
      strokeLinecap="round"
    />
    <path
      d="M18.6916 24.4998C19.9313 24.31 23.0314 25.0378 24.1767 26.8531C25.0928 28.3053 23.8419 30.0833 23.1019 30.7908L25.8383 32.5945"
      stroke="#CF0A80"
      strokeWidth="1.52859"
      strokeLinecap="round"
    />
    <path
      d="M12.5205 14.3927C17.0117 13.1983 19.2573 18.7407 19.3051 19.8396C22.6497 19.8396 22.4021 22.814 21.6941 23.8053C21.2163 24.4742 20.0218 25.6209 17.3462 26.5287C14.6705 27.4365 11.756 27.8187 10.9438 27.7232C10.1315 27.6276 9.08037 27.7232 8.3159 25.9075C7.70433 24.4551 8.76184 23.2956 9.27149 22.8975C8.69814 20.2218 8.02923 15.5872 12.5205 14.3927Z"
      fill="url(#paint7_linear_984_3740)"
    />
    <ellipse
      cx="0.62113"
      cy="0.66891"
      rx="0.62113"
      ry="0.66891"
      transform="matrix(-0.914359 0.404904 0.404904 0.914359 17.76 19.5088)"
      fill="#3B314F"
    />
    <ellipse
      cx="0.62113"
      cy="0.66891"
      rx="0.62113"
      ry="0.66891"
      transform="matrix(-0.914359 0.404904 0.404904 0.914359 13.5559 20.749)"
      fill="#3B314F"
    />
    <path
      d="M12.9106 26.7704C14.0096 25.8114 15.9126 25.0025 17.5296 25.7559C18.8233 26.3586 18.7734 28.9951 18.5868 30.2381L21.4509 29.8784"
      stroke="#CF0A80"
      strokeWidth="1.52859"
      strokeLinecap="round"
    />
    <path
      d="M10.4656 23.3862C9.71841 24.5382 8.89648 27.8882 11.5864 32.0726"
      stroke="#CF0A80"
      strokeWidth="1.52859"
      strokeLinecap="round"
    />
    <defs>
      <filter
        id="filter0_f_984_3740"
        x="21.9902"
        y="-9.67676"
        width="65.8662"
        height="83.1743"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="7.5"
          result="effect1_foregroundBlur_984_3740"
        />
      </filter>
      <linearGradient
        id="paint0_linear_984_3740"
        x1="37.9643"
        y1="40.8916"
        x2="37.9643"
        y2="54.4632"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F783F2" />
        <stop offset="1" stopColor="#E040DA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_984_3740"
        x1="44.4854"
        y1="5.26389"
        x2="45.9754"
        y2="20.5246"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F783F2" />
        <stop offset="1" stopColor="#E040DA" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_984_3740"
        x1="65.8551"
        y1="39.0166"
        x2="65.8551"
        y2="52.5289"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F783F2" />
        <stop offset="1" stopColor="#E040DA" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_984_3740"
        x1="30.8827"
        y1="40.8875"
        x2="23.3158"
        y2="45.8258"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E04D40" />
        <stop offset="1" stopColor="#F15F56" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_984_3740"
        x1="15.9451"
        y1="25.9191"
        x2="15.8128"
        y2="60.321"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F46A6A" />
        <stop offset="1" stopColor="#EA5749" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_984_3740"
        x1="23.9946"
        y1="40.9772"
        x2="16.4278"
        y2="45.9155"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF6F66" />
        <stop offset="1" stopColor="#EF6058" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_984_3740"
        x1="15.4868"
        y1="63.4712"
        x2="15.4888"
        y2="54.2896"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DA4639" />
        <stop offset="1" stopColor="#EC5B4F" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_984_3740"
        x1="15.1324"
        y1="14.2251"
        x2="15.1324"
        y2="27.7374"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F783F2" />
        <stop offset="1" stopColor="#E040DA" />
      </linearGradient>
    </defs>
  </SvgIcon>
));
